module.exports = __webpack_public_path__ + "static/media/contract.d0938b24.png";